module.exports = __webpack_public_path__ + "assets/img/desktop.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/desktop.png
// module id = 1938
// module chunks = 0